import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse,
  headersWithoutAuthWithoutBody
} from "../../../APIHelpers/Responses";

export const storeProductServices = {
  addNewStoreProduct,
  updatedStoreProduct,
  softDeleteRestoreStoreProduct,
  deleteStoreProduct,
  getStoreProductList,
  getPublicStoreProductList,
  getPublicSingleStoreProduct,
};

// Add New Product
async function addNewStoreProduct(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStoreProduct`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Update Product
async function updatedStoreProduct(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedStoreProduct`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Soft Delete & Restore Product
async function softDeleteRestoreStoreProduct(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStoreProduct`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Product
async function deleteStoreProduct(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStoreProduct`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Product
async function getStoreProductList(status, search, page, length) {
  try {
    const signal = cancelPreviousRequest(`getStoreProductList`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getStoreProductList/${status}?search=${search || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getStoreProductList/${status}?search=${search || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Public Product
async function getPublicStoreProductList(pageIdentifier, search, page, length) {
  try {
    const signal = cancelPreviousRequest(`getPublicStoreProductList`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getPublicStoreProductList/${pageIdentifier}?search=${search || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getPublicStoreProductList/${pageIdentifier}?search=${search || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithoutAuthWithoutBody("GET"),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Public Single Product
async function getPublicSingleStoreProduct(productId) {
  let apiURL = `${config.API_URL_USER_ONBOARDING}getPublicSingleStoreProduct/${productId}`;
  const response = await fetch(apiURL, headersWithoutAuthWithoutBody("GET"));
  const result = await response.json();
  const data = decryptResponse(result);
  if (data?.statusCode === 401) {
    handleResponse(data)
  }
  return data;
}